import Multiselect from 'vue-multiselect';
import CryptoJS from 'crypto-js';
import Loader from '../../../shared/components/loader';
import Treeselect from '@riophae/vue-treeselect';
import TripServices from '../../services/firstAndLastmilemanagement.service';
import Papa from "papaparse";
import moment from 'moment';
import Util from './../../../shared/util/util';

export default {
  name: 'ftcreports',
  components: {
    moment,
    Treeselect,
    Multiselect,
    CryptoJS,
    Loader,
    Papa
  },
  data: function () {
    return {
      isLoading: false,
      reportslist: [
        { id: 1, label: "FTC Outstanding Report" },
        { id: 2, label: "FTC Delivered/RAD AWB Wise Report" },
        { id: 3, label: "Finance Settlement Report" },
      ],
      awbstatuslist: [
        { id: 1, label: "RAD" },
        { id: 2, label: "Delivered" },
        { id: 3, label: "All" },
      ],
      awbstatus: 3,
      currentdate:moment().tz('Asia/Kolkata').format('YYYY-MM-DD'),
      reporttype: null,
      selectedhub: null,
      hublist: [],
      HubName: "",
      depositFromDate: "",
      depositToDate: "",
      deliveryFromDate : "",
      deliveryToDate : ""
    };
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem(
      'cargoAutoaccessuserdata'
    )
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
    var plaintext = bytes.toString(CryptoJS.enc.Utf8)
    var userdetail = JSON.parse(plaintext)
    this.hubid = userdetail.hubID[0];
    this.localuserid = userdetail.userid;
    this.isLoading = true;
    await this.getHubAccessList();
    this.isLoading = false;
  },
  methods: {
    formatDate(date){
      if (date == null || date == '') return '--';
    return moment.utc(date).format('DD-MM-YYYY');
    },
    async downloadreport() {
      this.isLoading = true;
      try {
        let reqPayload = {
          reporttype: this.reporttype
        };
        if (this.selectedhub && this.selectedhub.length) reqPayload.hubids = this.selectedhub.map(el=>el.hubid);
        if(this.reporttype == 2){
          reqPayload.awbstatus = this.awbstatus == 1 ? 'rad' : this.awbstatus == 2 ? 'delivered' : 'all';
          if(this.depositFromDate) reqPayload.radfromdate = this.depositFromDate;
          if(this.depositToDate) reqPayload.radtodate = this.depositToDate;
          if(this.deliveryFromDate) reqPayload.deliveryfromdate = this.deliveryFromDate;
          if(this.deliveryToDate) reqPayload.deliverytodate = this.deliveryToDate;
        }
        if(this.reporttype == 3){
          if(this.depositFromDate) reqPayload.depositfromdate = this.depositFromDate;
          if(this.depositToDate) reqPayload.deposittodate = this.depositToDate;
        }
        let reportData = await TripServices.getFtcReport(reqPayload); 
        if(reportData.data.code == 200){
          if(reportData.data.data && reportData.data.data.length ==0 ){
            this.$alertify.error("No data found")
          }else{
            var exceldata = [];
            exceldata = reportData.data.data.map((el,index)=>{
              if(this.reporttype == 1){
                return {
                  "Hub Name" : el.hubname,
                  "Hub ID" : el.hubid,
                  "Total FTC Amount" : el.totalftcamount,
                  "Total Amount Deposited" : el.totaldeposited,
                  "Total Amount Pending for Deposit" : el.depositpending,
                  "Total Amount Pending Verification" : el.tobeverifiedamount,
                  "Verified Amount" : el.verifiedamount,
                  "Excess Amount": el.excessamount
                }
              }else if(this.reporttype == 2){
                return el
              }else{
                return {
                  'Sr No': index+1,
                  'Hub' : `${el.hubname?el.hubname:''} (${el.hubid})`,
                  'Trip Id' : el.tmstripid ? el.tmstripid : 'Consignee pickup',
                  'Trip End Date' : el.tmstripid ? this.formatDate(el.tripenddate) : "NA",
                  'AWB' : el.awb,
                  'FTC Amount (INR)': el.ftctotalamtwogst ? this.calculatePercent(el.ftctotalamtwogst,18)  : Number(el.ftcamount),
                  'TDS Amount (INR)': el.tdsdeductedamount,
                  'Amount Collected (INR)' : Number(el.ftccashpayment),
                  'Total Amount Deposited' : Number(el.ftccashpayment) - Number(el.ftcsettlementpendingamt),
                  "Deposit ID": el.ftcdepositid ? el.ftcdepositid.join(','):'',
                  'Delivery Date and Time': el.tmstripid ? el.awbdeliverydate ? this.formatDate(el.awbdeliverydate) :"" : "NA",
                  // Deposit Status and date need to fetch
                  'Deposit Date': el.depositdate ? Util.displayDateOnlyFormat(el.depositdate) : '',
                  'Deposit by': el.depositby ? el.depositby : '',
                  'Deposit Creation Date': el.depositcreateddate ? Util.displayDateOnlyFormat(el.depositcreateddate) : '',
                  'Finance Verification Date': (el.depositsstatus === 1 || el.depositsstatus === 2) ? Util.displayDateOnlyFormat(el.depositlastmodifieddate) : '',
                  "Verified by": (el.depositsstatus === 1 || el.depositsstatus === 2) ? el.depositlastmodifiedby : '',
                  "Settlement status" : el.ftcamountsettled?'Settled':'Unsettled'
                }
              }
            })
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          this.makeXls(exceldata,'FTCReport' + dt);
          }
        }else{
          console.log(reportData.data.message)
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    calculatePercent(value,percent){
      let gst =  Number(Number((value/100)*percent).toFixed(2)) ;
      return Math.round(Number(Number(value) + Number(gst)))
    },
    makeXls(xlsdata,name){
			var blob = new Blob([Papa.unparse(xlsdata)], { type: 'text/csv;charset=utf-8;' });
			var link = document.createElement("a");
			var url = URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", name);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			return
		},
    selectHub(data) {
      this.selectedHub = data;
      this.originSearch = data.value;
    },
    async getHubAccessList() {
      try {
        let response = await TripServices.GetHublist()
        let list = response.data.data.data;
        list.forEach(el => {
          this.hublist.push({
            'hubid': el.HubID,
            'hubname': el.HubName
          })
        })
      } catch (err) {
        console.log(err)
      }
    },
    async resetFilter() {
      try {
        this.reporttype = null;
        this.awbstatus = 3;
        this.selectedhub = null;
        this.depositFromDate = null;
        this.depositToDate = null;
      } catch (err) {
        console.log(err)
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/ftcreports/ftcreports.component.js